import { SET_FOOTER_TAB } from './actions';

// Add interface
export const setActiveFooter = (payload: 'Chat' | 'Knowledge Base' | 'Tickets') => ({
  type: SET_FOOTER_TAB,
  payload
});
